/* ==========================================================================
   MAISON REVØRA — Produktseite (Shopify-Theme, 16.10.2026)  ·  /products/<handle>?f=<Farbe> | ?variant=<id>
   Aus dem Vorschau-Prototyp (src/page-product.js) übernommen:
   Galerie (nur gewählte Farbe, Modellbild zuerst) · Lightbox mit Zoom/Wischen · Sticky-Infos · Farbe/Größe ·
   Größentabelle-/Passform-Drawer · Akkordeons · Le Motif · Komplettiere den Look · Aus der Kollektion · Zuletzt angesehen
   Neu im Theme: echte URLs (?variant= per replaceState), Warenkorb über RV.cart.add (Ajax), Pflichtangaben aus
   der Section (#rvp-t-*), Maße je Warengruppe (rv-masse), Wieder-da-Formular (Klaviyo wie assets/rv-bis.js),
   Set mit der Open-Hem-Jogger (wie snippets/rv-set), DE + /en/.
   ========================================================================== */
(function () {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = RV.esc;
  const F = RV.D.fakten;
  const EN = (RV.cfg || {}).locale === "en";
  const T = (de, en) => (EN ? en : de);
  const KEY_RECENT = "rv_recent";
  const reduce = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isDesk = () => window.matchMedia("(min-width: 900px)").matches;
  const beh = () => (reduce() ? "auto" : "smooth");
  let CFG = {};
  try { CFG = JSON.parse(($("#rvp-cfg") || {}).textContent || "{}"); } catch (e) { CFG = {}; }
  const tpl = (id) => { const t = document.getElementById(id); return t ? t.innerHTML.trim() : ""; };

  /* Typ -> Kategorie-Kollektion (Brotkrumen), Themen-Kollektionen (Schiene) */
  const CAT = { "Unisex-Shirts": "t-shirts", Hoodies: "hoodies", Sweatshirts: "sweatshirts", "Zip-Hoodies": "zip-hoodies", Longsleeves: "longsleeves", Jacken: "jacken", Fleecejacken: "jacken", Caps: "accessoires", Jogger: "jogger", "Open-Hem-Jogger": "jogger" };
  const THEMES = ["winter", "azur-club", "riviera"];
  const COMPLEMENT = ["ro-jogger", "ro-dad-cap", "revora-clean-bomberjacke", "revora-clean-fleecejacke", "ro-open-hem-jogger"];
  const catOf = (p) => { const h = CAT[p.ty]; if (h && RV.coll(h) && p.col.includes(h)) return h; return p.col.find((x) => x !== "all" && RV.coll(x)) || "all"; };
  const themeOf = (p) => THEMES.find((h) => p.col.includes(h) && RV.coll(h)) || catOf(p);
  /* Logo-Teile (RØ / REVØRA / REVØRA Clean) tragen kein Motiv im Sinne von „gleiches Motiv“ */
  const LOGO = /^(RØ|REVØRA)(\s+Clean)?$/;
  const MOTIF_TY = ["Unisex-Shirts", "Hoodies", "Sweatshirts", "Zip-Hoodies", "Longsleeves"];
  const isLogo = (p) => LOGO.test(RV.splitTitle(p)[0]);
  const hasMotif = (p) => MOTIF_TY.includes(p.ty) && !isLogo(p);
  const catKey = (p) => CAT[p.ty] || p.ty;
  /* Packshot mit eigenem Studio-Grau (kein Weiß) – randlos statt Kasten im Kasten */
  const ownBg = (p, im) => /Jogger$/.test(p.ty) && im.k === "front";
  const TOPS = ["Hoodies", "Unisex-Shirts", "Sweatshirts", "Longsleeves", "Zip-Hoodies"];
  /* Größen in echter Reihenfolge (wie rv-produkt: der Lieferant hängt XS hinten an) */
  const SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL", "5XL"];
  function sortSizes(p) {
    if (p._ss || !p.s.length) return;
    const rank = (i) => { const k = SIZE_ORDER.indexOf(p.s[i]); return k < 0 ? 100 + i : k; };
    const idx = p.s.map((_, i) => i).sort((a, b) => rank(a) - rank(b));
    const map = {}; idx.forEach((old, nw) => (map[old] = nw));
    p.s = idx.map((i) => p.s[i]);
    p.v.forEach((v) => (v[2] = map[v[2]]));
    p._ss = 1;
  }

  /* Eigene feine Linien-Icons */
  const ICO = {
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15"><circle cx="12" cy="12" r="8.6"/><path d="M12 7.2V12l3.2 2"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" stroke-linejoin="round"><path d="M2.6 6.4h11.2v9.4H2.6z"/><path d="M13.8 9.4h3.9l3 3.1v3.3h-6.9"/><circle cx="6.8" cy="17.4" r="1.7" fill="#fff"/><circle cx="17" cy="17.4" r="1.7" fill="#fff"/></svg>',
    ret: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" stroke-linejoin="round"><path d="M9.2 5.8 5 10l4.2 4.2"/><path d="M5 10h9.6a4.6 4.6 0 0 1 0 9.2H11"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15"><path d="M12 21s-6.6-5.7-6.6-11.1a6.6 6.6 0 0 1 13.2 0C18.6 15.3 12 21 12 21Z"/><circle cx="12" cy="9.9" r="2.3"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" stroke-linejoin="round"><path d="M2.8 15.6 15.6 2.8l5.6 5.6L8.4 21.2z"/><path d="m6.6 11.8 1.9 1.9M9.4 9l1.3 1.3M12.2 6.2l1.9 1.9"/></svg>',
    left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="m15 5-7 7 7 7"/></svg>',
  };

  /* ---------- Daten-Helfer ---------- */
  /* Galerie einer Farbe: Modellbild (c.card) zuerst, Rest in Datenreihenfolge, keine Fremdbilder.
     Jacken: Detailbild ist ein hochskalierter Ausschnitt (unscharf) – bis zum Neu-Export ausgeblendet */
  const galleryImages = (p, c) => {
    const first = c.im[c.card] || c.im[0];
    return [first].concat(c.im.filter((x) => x !== first && x.k !== "other" && !(p.ty === "Jacken" && x.k === "detail")));
  };
  const ratio = (im) => (im.w || 4) / (im.h || 5);
  const arOf = (im) => `${im.w || 4}/${im.h || 5}`;
  /* Layout der Desktop-Galerie: Modell groß; bei ungerader Restzahl das nächste (meist Rückansicht) groß, Rest paarweise.
     Paare im echten Seitenverhältnis (nichts abgeschnitten); weicht eins ab, gilt das höhere, das andere wird eingepasst */
  const galleryLayout = (ims) => {
    const out = [{ im: ims[0], full: true, ar: arOf(ims[0]) }];
    const q = ims.slice(1);
    if (q.length % 2 === 1) {
      const miss = (l) => { let n = 0; for (let i = 0; i + 1 < l.length; i += 2) n += Math.abs(ratio(l[i]) - ratio(l[i + 1])) > 0.02 ? 1 : 0; return n; };
      let best = 0, bm = Infinity;
      q.forEach((_, i) => { const m = miss(q.slice(0, i).concat(q.slice(i + 1))); if (m < bm) { bm = m; best = i; } });
      const im = q.splice(best, 1)[0]; out.push({ im, full: true, ar: arOf(im) });
    }
    for (let i = 0; i < q.length; i += 2) {
      const a = q[i], b = q[i + 1];
      const tall = ratio(a) <= ratio(b) ? a : b;
      [a, b].forEach((im) => out.push({ im, full: false, ar: arOf(tall), fit: Math.abs(ratio(im) - ratio(tall)) > 0.02 }));
    }
    return out;
  };

  /* Beschreibung zerlegen: Einleitung, Listenpunkte (Label: Wert) – DE und EN (Translate & Adapt) */
  const K = {
    blank: /^(Rohling|Blank)$/i, origin: /(?:Herkunft|origin:?)\s+([^,;.]+)/i,
    mat: /^(Material|Pflege|Care)$/i, matOnly: /^Material$/i, motif: /^(Motiv|Design)$/i,
    cut: /^(Schnitt|Form|Cut|Shape)$/i, size: /^(Größe|Size)$/i, motifSize: /^(Motiv|Design|Größe|Size)$/i,
  };
  const parseDesc = (p) => {
    const t = document.createElement("template");
    t.innerHTML = p.d || "";
    const root = t.content;
    const intro = [];
    for (const n of Array.from(root.children)) { if (n.tagName === "UL" || n.tagName === "STRONG") break; if (n.tagName === "P") intro.push(n.textContent.trim()); }
    const all = $$("li", root).map((li) => {
      const s = li.textContent.trim();
      const m = s.match(/^([^:]{2,24}):\s*(.+)$/);
      return m ? { k: m[1].trim(), v: m[2].trim(), s } : { k: "", v: s, s };
    });
    /* Rohling-Zeile (Blank-Hersteller) nie zeigen – nur das Herkunftsland daraus übernehmen */
    const rohling = all.find((x) => K.blank.test(x.k));
    const origin = rohling ? ((rohling.v.match(K.origin) || [])[1] || "").trim() : "";
    const PRINT = /,?\s*(?:[–-]\s*)?(?:beides\s+)?nach deiner Bestellung in Deutschland gedruckt/i;
    const items = all.filter((x) => x !== rohling).map((x) => {
      if (K.matOnly.test(x.k)) return { ...x, v: x.v.replace(/\s*[–-]\s*[^–]*\b(by|von)\b[^–]*$/i, "").replace(/\s*\(Belcoro-Garn\)/i, "").trim() };
      if (!x.k && PRINT.test(x.v)) { const v = x.v.replace(PRINT, "").replace(/\s+;/, ";").trim(); return v.length < 14 || /\bwird$/.test(v) ? null : { ...x, v }; }
      return x;
    }).filter(Boolean);
    /* Einleitung der Shirts: Motivsatz (für Le Motif) + SEO-Satz (bleibt in der Beschreibung) */
    let lead = "", rest = intro.slice();
    if (intro[0]) {
      const k = intro[0].search(/Oversized T-?Shirt (für|for)\b/i);
      if (k > 0) { lead = intro[0].slice(0, k).trim().replace(/[\s:–-]+$/, ""); if (!/[.!?]$/.test(lead)) lead += "."; rest = [intro[0].slice(k)].concat(intro.slice(1)); }
      else { lead = intro[0]; rest = intro.slice(1); }
    }
    const HK = T("Herkunft", "Origin");
    const mat = [];
    items.filter((x) => K.mat.test(x.k)).forEach((x) => { mat.push(x); if (K.matOnly.test(x.k) && origin) mat.push({ k: HK, v: origin }); });
    if (origin && !mat.some((x) => x.k === HK)) mat.push({ k: HK, v: origin });
    return {
      intro, lead, rest, items,
      motif: items.find((x) => K.motif.test(x.k)),
      cut: items.find((x) => K.cut.test(x.k)),
      size: items.find((x) => K.size.test(x.k)),
      mat,
      feat: items.filter((x) => !K.mat.test(x.k) && !K.motifSize.test(x.k)),
    };
  };

  /* Maße je Warengruppe aus der Section (Shirt-Tabelle bzw. snippets/rv-masse, übersetzt) */
  const masse = () => {
    const t = $("#rvp-t-masse");
    if (!t) return null;
    const r = t.content;
    const tbl = $("table", r);
    let sizes = [], meas = [];
    if (tbl) {
      sizes = $$("thead th", tbl).map((x) => x.textContent.trim()).slice(1);
      meas = $$("tbody tr", tbl).map((tr) => { const c = $$("td", tr).map((x) => x.textContent.trim()); return { k: c[0], v: c.slice(1) }; }).filter((m) => m.v.length === sizes.length);
    }
    const notes = $$("p:not([data-intro])", r).map((x) => x.innerHTML.trim()).filter(Boolean);
    const guide = $("[data-guide]", r);
    return {
      sizes, meas, notes,
      intro: (($("[data-intro]", r) || {}).textContent || "").trim(),
      fit: (($("[data-fit]", r) || {}).textContent || "").trim(),
      guide: guide ? guide.getAttribute("href") : RV.link("pages/grossentabelle"),
      table: sizes.length > 0 && meas.length > 0,
    };
  };

  const priceHTML = (p, ci, si) => {
    const v = si >= 0 ? RV.variant(p, ci, si) : null;
    const now = v ? v[3] : p.p, was = v ? v[4] : p.cp;
    return (was && was > now ? `<s>${RV.price(was)}</s> ` : "") + RV.price(now);
  };
  /* Typografie für Überschriften: gerader Apostroph -> typografischer (nur Anzeige) */
  const typo = (s) => String(s).replace(/'/g, "’");
  const cap1 = (s) => String(s).charAt(0).toUpperCase() + String(s).slice(1);
  const italicLast = (s) => {
    s = typo(s);
    const w = String(s).split(" ");
    if (w.length < 2) return `<span class="rv-it">${esc(s)}</span>`;
    const last = w.pop();
    return `${esc(w.join(" "))} <span class="rv-it">${esc(last)}</span>`;
  };

  /* ---------- Bausteine ---------- */
  function galleryHTML(p, ci) {
    const c = p.c[ci];
    const lay = galleryLayout(galleryImages(p, c));
    const n = lay.length;
    return lay.map(({ im, full, ar, fit }, i) => {
      const sizes = full ? "(max-width:899px) 100vw, 62vw" : "(max-width:899px) 100vw, 31vw";
      const own = ownBg(p, im);
      const flat = !own && (im.k === "back" || im.k === "front");
      const cls = `rvp-fig ${full ? "rvp-fig--full" : "rvp-fig--half"}${flat ? " rvp-fig--flat" : ""}${own ? " rvp-fig--own" : ""}${fit ? " rvp-fig--fit" : ""}`;
      return `<figure class="${cls}" style="--ar:${ar}" data-k="${esc(im.k)}" data-i="${i}"${i ? ' data-reveal="fade"' : ""}>
        <button type="button" class="rvp-fig__b" data-lb="${i}">${RV.imgTag(im.u, { w: full ? 1200 : 800, sizes, alt: im.a, eager: i === 0, ws: [540, 720, 900, 1200, 1600, 2000] })}<span class="rvp-sr">${T(`Bild ${i + 1} von ${n} vergrößern`, `Enlarge image ${i + 1} of ${n}`)}</span></button></figure>`;
    }).join("");
  }
  const galleryList = (p, ci) => galleryLayout(galleryImages(p, p.c[ci])).map((x) => x.im);

  /* Farb-Thumbs: Rückansicht bzw. Front-Packshot zeigt die Farbe des Teils, nicht das Outfit */
  function colorsHTML(p, ci) {
    return p.c.map((c, i) => {
      const th = c.im.find((x) => x.k === "back") || c.im.find((x) => x.k === "front") || c.im[c.card] || c.im[0];
      return `<button type="button" class="rvp-col" data-ci="${i}" aria-pressed="${i === ci}" aria-label="${T("Farbe", "Colour")} ${esc(c.n)}" style="--c:${esc(c.x)}">
        <span class="rvp-col__im${ownBg(p, th) ? " is-own" : ""}">${RV.imgTag(th.u, { w: 200, sizes: "72px", alt: "", ws: [160, 200, 300] })}<i aria-hidden="true"></i></span>
        <span class="rvp-col__n">${esc(c.n)}</span></button>`;
    }).join("");
  }

  /* Größen: nicht verfügbare bleiben anklickbar (statt Warenkorb erscheint das Wieder-da-Formular) */
  function sizesHTML(p, ci, si) {
    if (!p.s.length) return "";
    return p.s.map((s, i) => {
      const ok = RV.isAvail(p, ci, i);
      return `<button type="button" class="rvp-sz${ok ? "" : " is-oos"}" data-si="${i}" aria-pressed="${i === si}"${ok ? "" : ` aria-label="${esc(s)} – ${T("nicht verfügbar", "unavailable")}" title="${T("Nicht verfügbar – benachrichtigen lassen", "Unavailable – get notified")}"`}><span>${esc(s)}</span></button>`;
    }).join("");
  }

  function accHTML(id, title, body, open) {
    return `<div class="rvp-acc__it${open ? " is-open" : ""}">
      <h3 class="rvp-acc__h"><button type="button" class="rvp-acc__b" id="rvp-accb-${id}" aria-expanded="${!!open}" aria-controls="rvp-acc-${id}">${title}<span class="rvp-acc__i" aria-hidden="true"></span></button></h3>
      <div class="rvp-acc__p" id="rvp-acc-${id}" role="region" aria-labelledby="rvp-accb-${id}"><div><div class="rvp-acc__in">${body}</div></div></div></div>`;
  }
  const dl = (rows) => rows.length ? `<dl class="rvp-dl">${rows.map((r) => `<dt>${esc(r.k)}</dt><dd>${esc(r.v)}</dd>`).join("")}</dl>` : "";

  /* Text der Le-Motif-Sektion (nur Motivteile) */
  const motifText = (dsc) => dsc.lead || (dsc.motif && cap1(dsc.motif.v)) || "";
  const motifOn = (p, dsc) => hasMotif(p) && !!motifText(dsc);

  /* Wieder-da-Formular (Texte aus der Section, rv.pdp.10-19) */
  const BT = Object.assign({ h: "Gerade nicht verfügbar", sub: "ist aktuell nicht bestellbar.", ph: "deine@email.de", btn: "Benachrichtigt mich", note: "", dse: "Datenschutz", dabei: "{v} ✓", mailfalsch: "E-Mail?", warte: "…", ok: "✓ {v}", fehler: "Fehler" }, CFG.bis || {});
  const bt = (k, v) => { let s = BT[k]; if (typeof s !== "string" || !s || /translation missing/i.test(s)) s = ""; return v == null ? s : s.split("{v}").join(v); };
  function bisHTML() {
    return `<div class="rvp-bis" id="rvp-bis" hidden>
      <div class="rvp-bis__h">${esc(bt("h"))}</div>
      <p class="rvp-bis__s"><b id="rvp-bis-v"></b> ${esc(bt("sub"))}</p>
      <div class="rvp-bis__row"><input class="rvp-bis__in" id="rvp-bis-mail" type="email" inputmode="email" autocomplete="email" placeholder="${esc(bt("ph"))}" aria-label="${esc(bt("ph"))}">
        <button type="button" class="rv-btn rvp-bis__btn" id="rvp-bis-btn">${esc(bt("btn"))}</button></div>
      <p class="rvp-bis__msg" id="rvp-bis-msg" role="status" aria-live="polite"></p>
      <p class="rvp-bis__note">${esc(bt("note"))} <a href="${esc(CFG.dse || RV.link("policies/privacy-policy"))}" target="_blank" rel="noopener">${esc(bt("dse"))}</a></p>
    </div>`;
  }

  /* Set mit der Open-Hem-Jogger (wie snippets/rv-set: gleiche Farbe wie das Oberteil, sonst Black; kein Set-Rabatt) */
  const SET_H = "ro-open-hem-jogger";
  const setOn = (p) => CFG.set && p.h !== SET_H && !!RV.prod(SET_H) && !RV.prod(SET_H).slim;
  const jogColor = (j, p, ci) => { const n = p.c[ci] ? p.c[ci].n : ""; const k = j.c.findIndex((c) => c.n === n); return k >= 0 ? k : Math.max(0, j.c.findIndex((c) => c.n === "Black")); };
  const setSize = (j, top) => { if (!top) return -1; const m = top === "XS" ? "S" : top === "3XL" ? "XXL" : top; return j.s.indexOf(m); };
  function setHTML(p, st) {
    if (!setOn(p)) return "";
    const j = RV.prod(SET_H); sortSizes(j);
    return `<div class="rvp-set" id="rvp-set">
      <div class="rvp-set__hd"><span class="rv-label">${T("Komplettiere das Set", "Complete the set")}</span><span class="rvp-set__sum" id="rvp-set-sum"></span></div>
      <div class="rvp-set__row">
        <a class="rvp-set__im" id="rvp-set-im" href="${RV.href.p(j.h)}"></a>
        <div class="rvp-set__txt"><a class="rvp-set__t" href="${RV.href.p(j.h)}">${esc(RV.nb(j.t))}</a>
          <div class="rvp-set__m"><span id="rvp-set-c"></span> · ${RV.price(j.p)}</div>
          <div class="rvp-set__sz" id="rvp-set-sz" role="group" aria-label="${T("Größe der Jogger", "Joggers size")}"></div></div>
      </div>
      <button type="button" class="rv-btn rv-btn--ghost rvp-set__go" id="rvp-set-go">${T("Set in den Warenkorb", "Add set to bag")}</button>
      <p class="rvp-set__msg" id="rvp-set-msg" aria-live="polite"></p>
    </div>`;
  }

  function infoHTML(st, dsc) {
    const { p, ci, si } = st;
    const [motif, art] = RV.splitTitle(p);
    const logo = isLogo(p);
    const shirt = p.ty === "Unisex-Shirts";
    const cat = catOf(p);
    const c = p.c[ci];
    const anyAvail = p.v.some((v) => v[1] === ci && v[5]);
    const mOn = motifOn(p, dsc);
    /* Akkordeon-Inhalte – nur Produktdaten + Fakten; mit Le Motif steht der Motivsatz nur dort */
    const introP = mOn ? dsc.rest : dsc.intro;
    const descBody = `${introP.map((t) => `<p>${esc(t)}</p>`).join("")}${!mOn && !dsc.intro.length && dsc.motif ? `<p>${esc(cap1(dsc.motif.v))}</p>` : ""}
      ${dl(dsc.feat.filter((x) => x.k))}
      ${dsc.feat.filter((x) => !x.k).length ? `<ul class="rvp-ul">${dsc.feat.filter((x) => !x.k).map((x) => `<li>${esc(x.v)}</li>`).join("")}</ul>` : ""}`;
    const matBody = dl(dsc.mat.concat(dsc.size ? [dsc.size] : []));
    const shipBody = `${dl([{ k: T("Versand", "Shipping"), v: F.versand }, { k: T("Lieferzeit", "Delivery"), v: F.lieferzeit }, { k: "DHL", v: F.dhl }, { k: T("Widerruf", "Withdrawal"), v: F.widerruf }].filter((r) => r.v))}
      <div class="rvp-acc__links"><a class="rv-link" href="${RV.href.seite("versand-lieferung")}">${T("Versand &amp; Lieferung", "Shipping &amp; delivery")}</a><a class="rv-link" href="${RV.href.seite("ruckgabe-umtausch")}">${T("Rückgabe &amp; Umtausch", "Returns &amp; exchanges")}</a></div>`;
    const gpsr = tpl("rvp-t-gpsr");
    const M = masse();
    const sizeLbl = shirt && M && M.table ? T("Größentabelle", "Size guide") : T("Passform", "Fit");

    const sizeBlock = p.s.length
      ? `<div class="rvp-opt__hd"><span class="rv-label">${T("Größe", "Size")}</span><span class="rvp-opt__v" id="rvp-sname">${si >= 0 ? esc(p.s[si]) : ""}</span>
          <button type="button" class="rvp-sizelink" id="rvp-sizelink">${ICO.ruler}<span>${sizeLbl}</span></button></div>
         <div class="rvp-sizes" id="rvp-sizes" role="group" aria-label="${T("Größe wählen", "Choose size")}" style="--n:${p.s.length}">${sizesHTML(p, ci, si)}</div>`
      : `<div class="rvp-opt__hd"><span class="rv-label">${T("Größe", "Size")}</span>
          <button type="button" class="rvp-sizelink" id="rvp-sizelink">${ICO.ruler}<span>${T("Passform", "Fit")}</span></button></div>
         <div class="rvp-one"><span class="rvp-one__chip">One Size</span>${dsc.size ? `<span class="rvp-one__t">${esc(dsc.size.v.replace(/^One Size,?\s*/i, ""))}</span>` : ""}</div>`;

    return `
      <nav class="rvp-crumbs" aria-label="${T("Brotkrumen", "Breadcrumb")}"><a href="${RV.href.home()}">Maison</a><span aria-hidden="true">/</span><a href="${RV.href.c(cat)}">${esc((RV.coll(cat) || {}).t || T("Alle Teile", "All pieces"))}</a></nav>
      <div class="rv-eyebrow rvp-eyebrow">${p.neu ? `<b>${T("Neu", "New")}</b><span aria-hidden="true"> · </span>` : ""}${esc(logo ? motif.split(/\s+/)[0] : RV.typeLabel(p))}</div>
      ${logo
        ? `<h1 class="rvp-title rvp-title--logo"><span class="rvp-sr">${esc(motif.split(/\s+/)[0])} </span><span class="rvp-title__m">${esc(RV.nb(motif.split(/\s+/).slice(1).concat(art).join(" ")))}</span></h1>`
        : `<h1 class="rvp-title"><span class="rvp-title__m">${esc(typo(motif))}</span> <span class="rvp-title__a">${esc(RV.nb(art))}</span></h1>`}
      <div class="rvp-price" id="rvp-price">${priceHTML(p, ci, si)}</div>
      <div class="rvp-taxbox" id="rvp-taxbox">${tpl("rvp-t-tax")}</div>

      <div class="rvp-opt">
        <div class="rvp-opt__hd"><span class="rv-label">${T("Farbe", "Colour")}</span><span class="rvp-opt__v" id="rvp-cname">${esc(c.n)}</span></div>
        <div class="rvp-colors" id="rvp-colors" role="group" aria-label="${T("Farbe wählen", "Choose colour")}">${colorsHTML(p, ci)}</div>
      </div>
      <div class="rvp-opt" id="rvp-sizewrap">${sizeBlock}
        <p class="rvp-hint" id="rvp-hint" aria-live="polite"></p>
      </div>

      ${bisHTML()}
      <div class="rvp-buy" id="rvp-buy">
        <button type="button" class="rv-btn rvp-add" id="rvp-add"${anyAvail ? "" : " disabled"}>${anyAvail ? T("In den Warenkorb", "Add to bag") : T("In dieser Farbe ausverkauft", "Sold out in this colour")}</button>
        <button type="button" class="rv-heart rvp-wish" data-h="${esc(p.h)}" aria-label="${T("Merken", "Save")}" aria-pressed="${RV.wish.has(p.h)}">${RV.icon("heart")}</button>
      </div>
      <p class="rvp-print"><span class="rvp-print__m" aria-hidden="true">${RV.monoSVG()}</span><span>${esc(F.druck)}</span></p>
      ${setHTML(p, st)}

      <ul class="rvp-prom" aria-label="${T("Unser Versprechen", "Our promise")}">
        <li>${ICO.clock}<span><b>${T("Lieferzeit", "Delivery time")}</b>${T("Deutschland 2–5, Schweiz 3–10 Werktage", "Germany 2–5, Switzerland 3–10 business days")}</span></li>
        <li>${ICO.truck}<span><b>${T("Kostenloser Versand", "Free shipping")}</b>${T("Standard nach DE · CH, ohne Mindestbestellwert", "Standard to DE · CH, no minimum order")}</span></li>
        <li>${ICO.ret}<span><b>${T("14 Tage Widerruf", "14-day withdrawal")}</b>${T("ab Erhalt – Anprobieren ausdrücklich erlaubt", "from receipt – trying on explicitly allowed")}</span></li>
        <li>${ICO.pin}<span><b>${T("DHL mit Tracking", "DHL with tracking")}</b>${T("Tracking-Link per E-Mail", "Tracking link by email")}</span></li>
      </ul>
      <div class="rvp-legalbox">${tpl("rvp-t-legal")}</div>

      <div class="rvp-acc" id="rvp-acc">
        ${accHTML("desc", T("Beschreibung", "Description"), descBody, !mOn)}
        ${matBody ? accHTML("mat", T("Material &amp; Pflege", "Material &amp; care"), matBody, false) : ""}
        ${accHTML("ship", T("Versand &amp; Rückgabe", "Shipping &amp; returns"), shipBody, false)}
        ${gpsr ? accHTML("gpsr", T("Herstellerangaben", "Manufacturer information"), gpsr, false) : ""}
      </div>`;
  }

  /* Le Motif — Editorial auf Navy-Canvas (Detailbild der gewählten Farbe) */
  function motifImg(p, ci) {
    const c = p.c[ci];
    return c.im.find((x) => x.k === "detail") || c.im.find((x) => x.k === "back") || c.im[c.card] || c.im[0];
  }
  function motifHTML(p, ci, dsc) {
    if (!motifOn(p, dsc)) return "";
    const im = motifImg(p, ci);
    const text = motifText(dsc);
    return `<section class="rvp-motif rv-canvas" aria-label="${T("Das Motiv", "The motif")}">
      <div class="rv-wrap rvp-motif__in">
        <div class="rvp-motif__img" data-reveal="fade"><div class="rvp-motif__frame" id="rvp-motif-frame">${RV.imgTag(im.u, { w: 1200, sizes: "(max-width:899px) 100vw, 46vw", alt: im.a, ws: [540, 720, 900, 1200, 1600] })}</div></div>
        <div class="rvp-motif__txt" data-reveal style="--d:.12s">
          ${RV.crest()}
          <div class="rv-eyebrow rvp-motif__ey">Le Motif</div>
          <h2 class="rv-h1">${italicLast(RV.splitTitle(p)[0])}</h2>
          <p class="rvp-motif__p">${esc(RV.nb(typo(text)))}</p>
          <div class="rv-double rvp-motif__rule" aria-hidden="true"></div>
        </div>
      </div></section>`;
  }

  /* Komplettiere den Look: gleiches Motiv in anderen Artikeln, aufgefüllt mit RØ-Basics und Oberteilen.
     Je Kategorie höchstens ein Teil, nie die eigene Kategorie; Logo-Teile zählen nicht als „gleiches Motiv“ */
  function lookList(p) {
    const motif = RV.splitTitle(p)[0];
    const used = new Set([catKey(p)]);
    const take = (x) => { if (!x || x === p || used.has(catKey(x))) return false; used.add(catKey(x)); return true; };
    const same = isLogo(p) ? [] : RV.D.products.filter((x) => x !== p && RV.splitTitle(x)[0] === motif).filter(take);
    const fill = COMPLEMENT.map(RV.prod).filter(Boolean).filter(take).slice(0, Math.max(0, 4 - same.length));
    const pool = RV.collProducts(themeOf(p)).concat(RV.D.products).filter((x) => hasMotif(x));
    const tops = [];
    TOPS.forEach((ty) => { if (same.length + fill.length + tops.length >= 4) return; const x = pool.find((y) => y.ty === ty && !used.has(catKey(y))); if (x && take(x)) tops.push(x); });
    const list = orderForColors((isLogo(p) ? tops.concat(fill) : same.concat(fill, tops)).slice(0, 4));
    return { list, same: same.length, allSame: same.length > 0 && same.length === list.length };
  }
  /* Reihenfolge so wählen, dass die Farbregel im 4er-Raster UND im 2-Spalten-Mobilraster hält */
  function orderForColors(list) {
    const ok = (l) => { const f = RV.pickColorsGrid(l, 4).map((x) => RV.fam(x.p.c[x.ci].n)); return f.every((v, i) => (i < 1 || f[i - 1] !== v) && (i < 2 || f[i - 2] !== v)); };
    if (list.length < 3 || ok(list)) return list;
    const perms = (a) => (a.length < 2 ? [a] : a.flatMap((x, i) => perms(a.slice(0, i).concat(a.slice(i + 1))).map((r) => [x].concat(r))));
    return perms(list).find(ok) || list;
  }
  function lookHTML(list, allSame) {
    if (!list.length) return "";
    return `<section class="rvp-sec rvp-look" aria-labelledby="rvp-look-h"><div class="rv-wrap">
      <div class="rvp-hd rvp-hd--c" data-reveal><div class="rv-eyebrow">${allSame ? T("Gleiches Motiv · neue Silhouette", "Same motif · new silhouette") : "Le Vestiaire"}</div>
        <h2 class="rv-h2" id="rvp-look-h">${T("Komplettiere den", "Complete the")} <span class="rv-it">Look</span></h2></div>
      <div class="rv-grid rvp-look__grid" style="--k:${list.length}">${RV.grid(list, { cols: Math.min(4, list.length), reveal: true, sizes: "(max-width:760px) 50vw, 25vw" })}</div>
    </div></section>`;
  }

  /* Schiene (Kollektion / Zuletzt angesehen) */
  function railHTML(id, eyebrow, title, list, o = {}) {
    if (!list.length) return "";
    const cards = RV.pickColors(list).map(({ p, ci }) => RV.card(p, ci, { sizes: o.small ? "(max-width:760px) 44vw, 16vw" : "(max-width:760px) 68vw, (max-width:1100px) 33vw, 25vw", badge: !o.small })).join("");
    return `<section class="rvp-sec rvp-rail${o.small ? " rvp-rail--sm" : ""}" aria-labelledby="${id}-h"><div class="rv-wrap">
      <div class="rvp-hd" data-reveal><div><div class="rv-eyebrow">${eyebrow}</div><h2 class="${o.small ? "rv-h3 rvp-rail__h3" : "rv-h2"}" id="${id}-h">${title}</h2></div>
        <div class="rvp-hd__r">${o.href ? `<a class="rv-link" href="${o.href}">${T("Alle ansehen", "View all")}</a>` : ""}
          <div class="rvp-arrs"><button type="button" class="rvp-arr rvp-arr--p" data-rail="${id}" data-dir="-1" aria-label="${T("Zurück", "Previous")}">${ICO.left}</button><button type="button" class="rvp-arr" data-rail="${id}" data-dir="1" aria-label="${T("Weiter", "Next")}">${RV.icon("chev")}</button></div></div></div>
      <div class="rvp-rail__track" id="${id}" data-reveal="fade">${cards}</div>
    </div></section>`;
  }

  /* Größentabelle-/Passform-Drawer */
  const SHIRT_SVG = `<svg class="rvp-sz__svg" viewBox="0 0 260 210" fill="none" aria-hidden="true">
    <path d="M92 18 66 24 20 52l17 42 25-11v108h136V83l25 11 17-42-46-28-26-6c-6 15-21 24-38 24s-32-9-38-24Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M92 18c6 15 21 24 38 24s32-9 38-24" stroke="currentColor" stroke-width="1.2"/>
    <g stroke="var(--navy)" stroke-width="1.2"><path d="M66 96h128"/><path d="m71 92-5 4 5 4M189 92l5 4-5 4"/>
    <path d="M214 24v167"/><path d="m210 29 4-5 4 5M210 186l4 5 4-5"/></g>
    <g font-family="RV Jost, sans-serif" font-size="11" letter-spacing="1.5" fill="var(--navy)" font-weight="500"><text x="124" y="114">A</text><text x="222" y="112">B</text></g></svg>`;

  function sizePanelHTML(p, si, dsc) {
    const shirt = p.ty === "Unisex-Shirts";
    const M = masse();
    const hasT = !!(M && M.table);
    const tableHTML = (letters) => {
      const head = M.meas.map((m, k) => `<th scope="col">${letters && k < 2 ? (k ? "B · " : "A · ") : ""}${esc(m.k)}</th>`).join("");
      const rows = M.sizes.map((s, r) => `<tr data-s="${esc(s)}"${si >= 0 && p.s[si] === s ? ' class="is-sel"' : ""}><th scope="row">${esc(s)}</th>${M.meas.map((m) => `<td data-cm="${esc(m.v[r])}">${esc(m.v[r])}</td>`).join("")}</tr>`).join("");
      return `<div class="rvp-szp__unit" role="group" aria-label="${T("Einheit", "Unit")}"><button type="button" data-unit="cm" aria-pressed="true">cm</button><button type="button" data-unit="in" aria-pressed="false">inch</button></div>
        <div class="rvp-szt__wrap"><table class="rvp-szt"><thead><tr><th scope="col">${T("Größe", "Size")}</th>${head}</tr></thead><tbody>${rows}</tbody></table></div>
        <p class="rvp-szp__unitnote" id="rvp-unitnote">${T("Angaben in cm.", "Measurements in cm.")}</p>
        ${M.notes.map((n) => `<p class="rvp-szp__p">${n}</p>`).join("")}`;
    };
    const guideBtn = hasT ? `<a class="rv-btn rv-btn--ghost rvp-szp__btn" href="${esc(M.guide)}">${T("Zur Größentabelle", "Full size guide")}</a>` : "";
    let body;
    if (shirt && hasT) {
      body = `<div class="rv-eyebrow rvp-szp__ey">${esc(RV.typeLabel(p))}</div><h2 class="rv-h2">${italicLast(M.fit || "Oversized Fit")}</h2>
        ${M.intro ? `<p class="rvp-szp__p">${esc(M.intro)}</p>` : ""}
        <div class="rvp-szp__fig">${SHIRT_SVG}<div class="rvp-szp__leg"><span><b>A</b> ${esc((M.meas[0] || {}).k || "")}</span><span><b>B</b> ${esc((M.meas[1] || {}).k || "")}</span></div></div>
        ${tableHTML(true)}${guideBtn}`;
    } else {
      const rows = [];
      if (dsc.cut) rows.push(dsc.cut);
      if (dsc.size) rows.push(dsc.size);
      dsc.items.filter((x) => /\d\s*cm/.test(x.v) && x !== dsc.size && x !== dsc.motif).forEach((x) => rows.push(x.k ? x : { k: T("Maße", "Measurements"), v: x.v }));
      if (p.s.length) rows.push({ k: T("Größen", "Sizes"), v: p.s.join(" · ") });
      body = `<div class="rv-eyebrow rvp-szp__ey">${esc(RV.typeLabel(p))}</div><h2 class="rv-h2">${T('Pass<span class="rv-it">form</span>', '<span class="rv-it">Fit</span>')}</h2>
        ${dl(rows)}
        ${hasT ? `<div class="rv-eyebrow rvp-szp__sub">${T("Maße", "Measurements")}</div>${tableHTML(false)}` : (M && M.notes.length ? M.notes.map((n) => `<p class="rvp-szp__p">${n}</p>`).join("") : "")}
        <p class="rvp-szp__p">${T("Fragen zur Passform dieses Teils? Schreib uns an", "Questions about the fit of this piece? Write to us at")} <a href="mailto:${esc(F.kontakt)}">${esc(F.kontakt)}</a>.</p>
        ${guideBtn}`;
    }
    return `<aside class="rv-panel rv-panel--r rvp-szp" id="rvp-size" role="dialog" aria-modal="true" aria-labelledby="rvp-szp-t">
      <div class="rv-panel__hd"><span class="rv-label" id="rvp-szp-t">${shirt && hasT ? T("Größentabelle", "Size guide") : T("Passform", "Fit")}</span><button type="button" class="rv-x" data-close aria-label="${T("Schließen", "Close")}">${RV.icon("close")}</button></div>
      <div class="rv-panel__bd"><div class="rvp-szp__in">${body}</div></div></aside>`;
  }

  function notFoundHTML() {
    return `<section class="rv-wrap rv-sec rv-center rvp-404"><div class="rv-eyebrow rv-muted">${T("Nicht gefunden", "Not found")}</div>
      <h1 class="rv-h1" style="margin:18px 0 26px">${T('Dieses Teil ist gerade <span class="rv-it">nicht da</span>', 'This piece is <span class="rv-it">not here</span>')}</h1>
      <a class="rv-btn" href="${RV.href.c("all")}">${T("Alle Teile ansehen", "View all pieces")}</a></section>`;
  }

  /* ---------- Seite ---------- */
  let S = null;

  RV.page("product", {
    header: "solid",
    render(el, ctx) {
      const p = RV.prod(ctx.params.h);
      if (!p) { el.innerHTML = notFoundHTML(); return; }
      sortSizes(p);
      /* Farbe vorwählen: ?f=<Farbe> oder ?variant=<id>; Größe bleibt bewusst offen (wie im Live-Theme) */
      let ci = RV.colorIndex(p, ctx.query.f || "");
      if (!ctx.query.f && ctx.query.variant) { const v = p.v.find((x) => String(x[0]) === String(ctx.query.variant)); if (v) ci = v[1]; }
      const st = { p, ci, si: p.s.length ? -1 : 0 };
      const dsc = parseDesc(p);
      const theme = themeOf(p);
      const look = lookList(p);
      const recentH = RV.store.get(KEY_RECENT, []).filter((h) => h !== p.h && typeof h === "string");
      RV.store.set(KEY_RECENT, [p.h].concat(recentH).slice(0, 12));
      let collList = RV.collProducts(theme).filter((x) => x !== p && !look.list.includes(x)).slice(0, 12);
      let collT = (RV.coll(theme) || {}).t || "", collH = theme, collEy = T("Aus der Kollektion", "From the collection");
      /* Zu kleine Kollektion (z. B. Accessoires = nur die Cap): Neu eingetroffen statt abruptem Ende */
      if (collList.length < 4 && RV.coll("neu-eingetroffen")) {
        collList = RV.collProducts("neu-eingetroffen").filter((x) => x !== p && !look.list.includes(x)).slice(0, 12);
        collT = T("Neu eingetroffen", "New arrivals"); collH = "neu-eingetroffen"; collEy = T("Weiter entdecken", "Keep exploring");
      }

      el.innerHTML = `<div class="rvp" id="rvp">
        <section class="rvp-main" aria-label="${esc(p.t)}">
          <div class="rvp-gal" id="rvp-gal">
            <div class="rvp-gal__track" id="rvp-track">${galleryHTML(p, st.ci)}</div>
            <div class="rvp-gal__ui" aria-hidden="true"><span class="rvp-gal__n" id="rvp-gn"></span><span class="rvp-gal__bars" id="rvp-gbars"></span></div>
          </div>
          <div class="rvp-info" id="rvp-info">${infoHTML(st, dsc)}</div>
        </section>
        ${motifHTML(p, st.ci, dsc)}
        ${lookHTML(look.list, look.allSame)}
        ${railHTML("rvp-coll", collEy, italicLast(collT), collList, { href: RV.href.c(collH) })}
        <div id="rvp-recent-slot"></div>
      </div>`;

      /* Overlays an body hängen (über Header/Scrim, außerhalb des Seiten-Stackings) */
      const holder = document.createElement("div");
      holder.className = "rvp-portal";
      holder.innerHTML = sizePanelHTML(p, st.si, dsc) + barHTML(p, st);
      document.body.appendChild(holder);

      S = { el, st, dsc, holder, off: [], obs: [], lb: null };
      wire(S);

      /* Zuletzt angesehen: fehlende Produkte über /products/<h>.js nachladen */
      const want = recentH.slice(0, 8);
      if (want.length) RV.fetchProducts(want).then(() => {
        if (!S || S.el !== el) return;
        const recent = want.map(RV.prod).filter(Boolean);
        if (!recent.length) return;
        const slot = $("#rvp-recent-slot", el);
        slot.outerHTML = railHTML("rvp-recent", T("Für dich", "For you"), T("Zuletzt angesehen", "Recently viewed"), recent, { small: true });
        const t = $("#rvp-recent", el);
        if (t) { S.railBind(t); RV.reveal(t.closest(".rvp-sec")); }
        RV.wish.sync();
      });
    },
  });

  function barHTML(p, st) {
    const c = p.c[st.ci], im = c.im[c.card] || c.im[0];
    return `<div class="rvp-bar" id="rvp-bar" inert>
      <div class="rvp-bar__in">
        <span class="rvp-bar__th" id="rvp-bar-th">${RV.imgTag(im.u, { w: 120, sizes: "48px", alt: "", ws: [96, 120, 160] })}</span>
        <span class="rvp-bar__info"><span class="rvp-bar__t">${esc(RV.nb(typo(p.t)))}</span><span class="rvp-bar__m" id="rvp-bar-m"></span><span class="rvp-bar__mp" id="rvp-bar-mp">${priceHTML(p, st.ci, st.si)}</span></span>
        <span class="rvp-bar__pr" id="rvp-bar-pr">${priceHTML(p, st.ci, st.si)}</span>
        <button type="button" class="rv-btn rvp-bar__btn" id="rvp-bar-add">${T("In den Warenkorb", "Add to bag")}</button>
      </div></div>`;
  }

  /* ---------- Verhalten ---------- */
  function wire(S) {
    const { el, st } = S;
    const p = st.p;
    const on = (t, ev, fn, o) => { if (!t) return; t.addEventListener(ev, fn, o); S.off.push(() => t.removeEventListener(ev, fn, o)); };
    const info = $("#rvp-info", el), track = $("#rvp-track", el), add = $("#rvp-add", el), buy = $("#rvp-buy", el);
    const bar = $("#rvp-bar"), barBtn = $("#rvp-bar-add"), hdr = $("#rv-hdr");
    const bis = $("#rvp-bis", el), bisMail = $("#rvp-bis-mail", el), bisBtn = $("#rvp-bis-btn", el), bisMsg = $("#rvp-bis-msg", el);

    /* Galerie-Zähler (mobil) */
    const updCount = () => {
      const figs = $$(".rvp-fig", track);
      const n = figs.length;
      const i = Math.min(n - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      $("#rvp-gn", el).textContent = `${i + 1} / ${n}`;
      const bars = $("#rvp-gbars", el);
      if (bars.childElementCount !== n) bars.innerHTML = figs.map(() => "<i></i>").join("");
      Array.from(bars.children).forEach((b, k) => b.classList.toggle("is-on", k === i));
    };
    let raf = 0;
    on(track, "scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(updCount); }, { passive: true });
    updCount();

    /* Lightbox öffnen */
    on(track, "click", (e) => { const b = e.target.closest("[data-lb]"); if (b) openLB(S, +b.dataset.lb, b); });

    /* URL ohne Neuaufbau: ?variant=<id> (gewählte Variante, sonst erste der Farbe) */
    const setUrl = () => {
      try {
        const v = (st.si >= 0 && RV.variant(p, st.ci, st.si)) || p.v.find((x) => x[1] === st.ci && x[5]) || p.v.find((x) => x[1] === st.ci);
        if (!v) return;
        const u = new URL(location.href);
        u.searchParams.delete("f");
        u.searchParams.set("variant", String(v[0]));
        history.replaceState(history.state, "", u.pathname + u.search + u.hash);
      } catch (e) {}
    };

    /* Farbe wechseln: Galerie tauschen, URL ersetzen (ohne Neuaufbau) */
    const setColor = (ci) => {
      if (ci === st.ci) return;
      st.ci = ci;
      const c = p.c[ci];
      $$(".rvp-col", el).forEach((b) => b.setAttribute("aria-pressed", String(+b.dataset.ci === ci)));
      $("#rvp-cname", el).textContent = c.n;
      const sz = $("#rvp-sizes", el);
      if (sz) sz.innerHTML = sizesHTML(p, ci, st.si);
      updSel();
      const gal = $("#rvp-gal", el);
      const swap = () => {
        track.innerHTML = galleryHTML(p, ci);
        track.scrollLeft = 0;
        updCount();
        RV.reveal(track);
        requestAnimationFrame(() => gal.classList.remove("is-swap"));
      };
      if (reduce()) swap(); else { gal.classList.add("is-swap"); setTimeout(swap, 260); }
      const fr = $("#rvp-motif-frame", el);
      if (fr) { const im = motifImg(p, ci); fr.innerHTML = RV.imgTag(im.u, { w: 1200, sizes: "(max-width:899px) 100vw, 46vw", alt: im.a, ws: [540, 720, 900, 1200, 1600] }); }
      const th = $("#rvp-bar-th"), cim = c.im[c.card] || c.im[0];
      if (th) th.innerHTML = RV.imgTag(cim.u, { w: 120, sizes: "48px", alt: "", ws: [96, 120, 160] });
      setUrl();
    };
    on($("#rvp-colors", el), "click", (e) => { const b = e.target.closest(".rvp-col"); if (b) setColor(+b.dataset.ci); });

    /* Wieder-da-Formular (gleiche Logik wie assets/rv-bis.js: öffentlicher Key, Metrik, Back-in-Stock-Abo) */
    const KL_KEY = "Wd2V7N", KL_METRIC = "Zurueck auf Lager angefragt";
    const wanted = () => p.c[st.ci].n + (p.s.length && st.si >= 0 ? " / " + p.s[st.si] : "");
    const bisKey = () => "rvBis:" + CFG.id + ":" + wanted();
    const bisSay = (text, ok) => { bisMsg.textContent = text; bisMsg.className = "rvp-bis__msg is-on " + (ok ? "is-ok" : "is-bad"); };
    const oosNow = () => { if (p.s.length && st.si < 0) return false; return !RV.isAvail(p, st.ci, st.si); };
    const updBuy = () => {
      const oos = oosNow();
      const anyAvail = p.v.some((v) => v[1] === st.ci && v[5]);
      bis.hidden = !oos;
      buy.hidden = oos;
      add.disabled = !anyAvail;
      if (!add.classList.contains("is-busy")) add.textContent = anyAvail ? T("In den Warenkorb", "Add to bag") : T("In dieser Farbe ausverkauft", "Sold out in this colour");
      barBtn.textContent = oos ? bt("btn") : T("In den Warenkorb", "Add to bag");
      if (oos) {
        $("#rvp-bis-v", el).textContent = wanted();
        if (RV.store.get(bisKey(), null)) bisSay(bt("dabei", wanted()), true);
        else bisMsg.className = "rvp-bis__msg";
      }
    };
    on(bisBtn, "click", () => {
      const mail = (bisMail.value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) { bisMail.classList.add("is-err"); bisSay(bt("mailfalsch"), false); return; }
      bisMail.classList.remove("is-err");
      bisBtn.disabled = true; bisBtn.textContent = bt("warte");
      bisMsg.className = "rvp-bis__msg";
      const v = RV.variant(p, st.ci, st.si);
      const label = wanted();
      const H = { "Content-Type": "application/json", revision: "2024-10-15" };
      const jobs = [fetch("https://a.klaviyo.com/client/events/?company_id=" + KL_KEY, {
        method: "POST", headers: H,
        body: JSON.stringify({ data: { type: "event", attributes: {
          properties: { Produkt: CFG.title || p.t, ProduktID: String(CFG.id || ""), Variante: label, VarianteID: v ? String(v[0]) : "", Grund: v ? "ausverkauft" : "Kombination nicht im Sortiment", URL: location.href, Bild: CFG.img || "" },
          metric: { data: { type: "metric", attributes: { name: KL_METRIC } } },
          profile: { data: { type: "profile", attributes: { email: mail } } } } } }),
      }).then((r) => r.ok).catch(() => false)];
      if (v) jobs.push(fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + KL_KEY, {
        method: "POST", headers: H,
        body: JSON.stringify({ data: { type: "back-in-stock-subscription",
          attributes: { profile: { data: { type: "profile", attributes: { email: mail } } }, channels: ["EMAIL"] },
          relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + v[0] } } } } }),
      }).then((r) => r.ok).catch(() => false));
      Promise.all(jobs).then((res) => {
        bisBtn.disabled = false; bisBtn.textContent = bt("btn");
        if (res.includes(true)) { RV.store.set("rvBis:" + CFG.id + ":" + label, 1); bisSay(bt("ok", label), true); bisMail.value = ""; }
        else bisSay(bt("fehler"), false);
      });
    });
    on(bisMail, "keydown", (e) => { if (e.key === "Enter") bisBtn.click(); });

    /* Größe */
    const hint = $("#rvp-hint", el);
    const low = $("[data-low]", el);
    const updSel = () => {
      const sn = $("#rvp-sname", el);
      if (sn) sn.textContent = st.si >= 0 ? p.s[st.si] : "";
      const ph = priceHTML(p, st.ci, st.si);
      $("#rvp-price", el).innerHTML = ph;
      if (low) low.hidden = !/<s>/.test(ph);
      $("#rvp-bar-pr").innerHTML = $("#rvp-bar-mp").innerHTML = ph;
      $("#rvp-bar-m").textContent = p.c[st.ci].n + (p.s.length ? " · " + (st.si >= 0 ? T("Größe ", "Size ") + p.s[st.si] : T("Größe wählen", "Choose size")) : " · One Size");
      $$("#rvp-size tbody tr").forEach((tr) => tr.classList.toggle("is-sel", st.si >= 0 && tr.dataset.s === p.s[st.si]));
      updBuy();
      updSet();
    };
    const sizesBox = $("#rvp-sizes", el);
    if (sizesBox) on(sizesBox, "click", (e) => {
      const b = e.target.closest(".rvp-sz");
      if (!b) return;
      st.si = +b.dataset.si;
      $$(".rvp-sz", sizesBox).forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      sizesBox.classList.remove("is-alert");
      hint.textContent = "";
      hint.classList.remove("is-on");
      updSel();
      setUrl();
    });
    const askSize = () => {
      hint.textContent = T("Bitte wähle zuerst deine Größe.", "Please choose your size first.");
      hint.classList.add("is-on");
      sizesBox.classList.remove("is-alert"); void sizesBox.offsetWidth; sizesBox.classList.add("is-alert");
      const r = sizesBox.getBoundingClientRect();
      if (r.top < 90 || r.bottom > window.innerHeight - 90) sizesBox.scrollIntoView({ block: "center", behavior: beh() });
      const f = $(".rvp-sz:not(.is-oos)", sizesBox) || $(".rvp-sz", sizesBox);
      f && f.focus({ preventScroll: true });
    };
    const toBis = () => {
      const r = bis.getBoundingClientRect();
      if (r.top < 90 || r.bottom > window.innerHeight - 90) bis.scrollIntoView({ block: "center", behavior: beh() });
      bisMail.focus({ preventScroll: true });
    };
    let busy = false;
    const doAdd = async () => {
      if (p.s.length && st.si < 0) { askSize(); return; }
      if (oosNow()) { toBis(); return; }
      if (busy) return;
      busy = true;
      add.classList.add("is-busy"); add.setAttribute("aria-busy", "true"); add.textContent = T("Einen Moment …", "One moment …");
      try { await RV.cart.add(p, st.ci, st.si, 1); } finally {
        busy = false; add.classList.remove("is-busy"); add.removeAttribute("aria-busy"); updBuy();
      }
    };
    on(add, "click", doAdd);
    on(barBtn, "click", doAdd);

    /* Set mit der Open-Hem-Jogger */
    const setBox = $("#rvp-set", el);
    const J = setBox ? RV.prod(SET_H) : null;
    let jsi = -1, jPicked = false;
    function updSet() {
      if (!setBox || !J) return;
      const jci = jogColor(J, p, st.ci);
      if (!jPicked) jsi = setSize(J, st.si >= 0 ? p.s[st.si] : "");
      if (jsi >= 0 && !RV.isAvail(J, jci, jsi)) { jsi = -1; jPicked = false; }
      const c = J.c[jci], im = c.im.find((x) => x.k === "front") || c.im[c.card] || c.im[0];
      const box = $("#rvp-set-im", el);
      if (box.dataset.u !== im.u) { box.innerHTML = RV.imgTag(im.u, { w: 300, sizes: "84px", alt: im.a, ws: [200, 300] }); box.dataset.u = im.u; box.classList.toggle("is-own", ownBg(J, im)); }
      $("#rvp-set-c", el).textContent = c.n;
      $("#rvp-set-sz", el).innerHTML = J.s.map((s, i) => { const ok = RV.isAvail(J, jci, i); return `<button type="button" class="rvp-set__b" data-j="${i}" aria-pressed="${ok && i === jsi}"${ok ? "" : " disabled"}>${esc(s)}</button>`; }).join("");
      const top = st.si >= 0 ? RV.variant(p, st.ci, st.si) : null;
      const jv = jsi >= 0 ? RV.variant(J, jci, jsi) : null;
      $("#rvp-set-sum", el).textContent = "Set " + RV.price((top ? top[3] : p.p) + (jv ? jv[3] : J.p));
    }
    if (setBox) {
      on($("#rvp-set-sz", el), "click", (e) => { const b = e.target.closest("[data-j]"); if (!b || b.disabled) return; jsi = +b.dataset.j; jPicked = true; $("#rvp-set-msg", el).textContent = ""; updSet(); });
      on($("#rvp-set-go", el), "click", async () => {
        const msg = $("#rvp-set-msg", el), go = $("#rvp-set-go", el);
        msg.textContent = "";
        if (p.s.length && st.si < 0) { askSize(); msg.textContent = T("Bitte zuerst oben eine Größe wählen.", "Please choose a size for the top first."); return; }
        const top = RV.variant(p, st.ci, st.si);
        if (!top || !top[5]) { toBis(); return; }
        const jv = jsi >= 0 ? RV.variant(J, jogColor(J, p, st.ci), jsi) : null;
        if (!jv || !jv[5]) { msg.textContent = T("Bitte eine Größe für die Jogger wählen.", "Please choose a size for the joggers."); return; }
        go.disabled = true; const old = go.textContent; go.textContent = T("Einen Moment …", "One moment …");
        try {
          const r = await fetch(RV.cfg.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: top[0], quantity: 1 }, { id: jv[0], quantity: 1 }] }) });
          if (!r.ok) { const e = await r.json().catch(() => ({})); msg.textContent = e.description || e.message || T("Konnte nicht hinzugefügt werden", "Could not add to bag"); }
          else { await RV.cart.refresh(); RV.cart.open(); }
        } catch (e) { msg.textContent = T("Keine Verbindung – bitte nochmal versuchen", "No connection – please try again"); }
        go.disabled = false; go.textContent = old;
      });
    }
    updSel();

    /* Größentabelle */
    on($("#rvp-sizelink", el), "click", () => { updSel(); RV.openPanel("rvp-size"); });
    const unitBox = $("#rvp-size .rvp-szp__unit");
    if (unitBox) on(unitBox, "click", (e) => {
      const b = e.target.closest("[data-unit]");
      if (!b) return;
      const inch = b.dataset.unit === "in";
      $$("button", unitBox).forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      $$("#rvp-size td[data-cm]").forEach((td) => {
        const cm = parseFloat(td.dataset.cm.replace(",", "."));
        td.textContent = inch && !isNaN(cm) ? (cm / 2.54).toLocaleString(EN ? "en-GB" : "de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : td.dataset.cm;
      });
      $("#rvp-unitnote").textContent = inch ? T("Angaben in inch, umgerechnet aus cm (1 inch = 2,54 cm).", "Measurements in inches, converted from cm (1 inch = 2.54 cm).") : T("Angaben in cm.", "Measurements in cm.");
    });

    /* Akkordeons */
    on($("#rvp-acc", el), "click", (e) => {
      const b = e.target.closest(".rvp-acc__b");
      if (!b) return;
      const it = b.closest(".rvp-acc__it");
      const open = !it.classList.contains("is-open");
      it.classList.toggle("is-open", open);
      b.setAttribute("aria-expanded", String(open));
    });

    /* Sticky-Info: oben unter dem Header; ist sie höher als das Fenster, scrollt sie mit und bleibt unten stehen */
    const updTop = () => {
      if (!isDesk()) return;
      const hh = hdr && !hdr.classList.contains("is-hidden") ? hdr.getBoundingClientRect().height : 0;
      const top = Math.min(hh + 28, window.innerHeight - info.offsetHeight - 28);
      info.style.setProperty("--rvp-top", Math.round(top) + "px");
    };
    let rafT = 0;
    const onScroll = () => { cancelAnimationFrame(rafT); rafT = requestAnimationFrame(updTop); };
    on(window, "scroll", onScroll, { passive: true });
    on(window, "resize", onScroll);
    if ("ResizeObserver" in window) { const ro = new ResizeObserver(onScroll); ro.observe(info); S.obs.push(ro); }
    if (hdr && "MutationObserver" in window) { const mo = new MutationObserver(onScroll); mo.observe(hdr, { attributes: true, attributeFilter: ["class"] }); S.obs.push(mo); }
    updTop();

    /* Sticky-Leiste: sobald der Kaufbereich oben aus dem Bild ist (aus, wenn der Footer kommt) */
    const ftr = $(".rv-ftr");
    const updBar = () => {
      const ref = buy.hidden ? bis : add;
      const ctaOut = ref.getBoundingClientRect().bottom < 0;
      const ftrIn = !!ftr && ftr.getBoundingClientRect().top < window.innerHeight - 40;
      const show = ctaOut && !ftrIn;
      if (show === bar.classList.contains("is-on")) return;
      bar.classList.toggle("is-on", show);
      if (show) bar.removeAttribute("inert"); else bar.setAttribute("inert", "");
      document.body.classList.toggle("rvp-has-bar", show);
    };
    let rafB = 0;
    on(window, "scroll", () => { cancelAnimationFrame(rafB); rafB = requestAnimationFrame(updBar); }, { passive: true });
    updBar();

    /* Schienen-Pfeile */
    const railUpd = (t) => {
      const max = t.scrollWidth - t.clientWidth - 2;
      $$(`[data-rail="${t.id}"]`, el).forEach((b) => { b.disabled = +b.dataset.dir < 0 ? t.scrollLeft <= 2 : t.scrollLeft >= max; });
    };
    S.railBind = (t) => { on(t, "scroll", () => railUpd(t), { passive: true }); railUpd(t); };
    $$(".rvp-rail__track", el).forEach(S.railBind);
    on(el, "click", (e) => {
      const b = e.target.closest("[data-rail]");
      if (!b) return;
      const t = $("#" + b.dataset.rail, el);
      t.scrollBy({ left: +b.dataset.dir * t.clientWidth * 0.8, behavior: beh() });
    });
    on(window, "resize", () => $$(".rvp-rail__track", el).forEach(railUpd));

    /* Escape / Tastatur für die Lightbox */
    on(document, "keydown", (e) => {
      if (!S.lb || !S.lb.classList.contains("is-on")) return;
      if (e.key === "Escape") { e.preventDefault(); closeLB(S); }
      else if (e.key === "ArrowRight") { e.preventDefault(); lbGo(S, S.lbI + 1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); lbGo(S, S.lbI - 1); }
      else if (e.key === "Tab") {
        const f = $$("button", S.lb).filter((x) => x.offsetParent !== null);
        if (!f.length) return;
        const i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  /* ---------- Lightbox: Vollbild, Wischen, Klick-Zoom mit Mitführen ---------- */
  function openLB(S, i, trigger) {
    const { p, ci } = S.st;
    const ims = galleryList(p, ci);
    if (S.lb) S.lb.remove();
    const lb = document.createElement("div");
    lb.className = "rvp-lb";
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", T("Bildansicht ", "Image view ") + p.t);
    lb.innerHTML = `
      <div class="rvp-lb__top"><span class="rvp-lb__n" id="rvp-lbn" aria-live="polite"></span>
        <button type="button" class="rv-x rvp-lb__x" aria-label="${T("Bildansicht schließen", "Close image view")}">${RV.icon("close")}</button></div>
      <div class="rvp-lb__track">${ims.map((im, k) => `<figure class="rvp-lb__s${(im.k === "back" || im.k === "front") && !ownBg(p, im) ? " rvp-lb__s--flat" : ""}" data-k="${k}">${RV.imgTag(im.u, { w: 1600, sizes: "100vw", alt: im.a, eager: k === i, ws: [900, 1200, 1600, 2000] })}</figure>`).join("")}</div>
      <button type="button" class="rvp-lb__nav rvp-lb__nav--p" aria-label="${T("Vorheriges Bild", "Previous image")}">${ICO.left}</button>
      <button type="button" class="rvp-lb__nav rvp-lb__nav--n" aria-label="${T("Nächstes Bild", "Next image")}">${RV.icon("chev")}</button>
      <div class="rvp-lb__thumbs">${ims.map((im, k) => `<button type="button" class="rvp-lb__th" data-k="${k}" aria-label="${T("Bild", "Image")} ${k + 1}">${RV.imgTag(im.u, { w: 160, sizes: "56px", alt: "", ws: [120, 160] })}</button>`).join("")}</div>`;
    document.body.appendChild(lb);
    S.lb = lb; S.lbI = i; S.lbTrigger = trigger;
    const tr = $(".rvp-lb__track", lb);
    document.body.classList.add("rv-lock", "rvp-lb-open");
    requestAnimationFrame(() => {
      tr.scrollLeft = i * tr.clientWidth;
      lbMark(S, i);
      lb.classList.add("is-on");
      $(".rvp-lb__x", lb).focus({ preventScroll: true });
    });

    $(".rvp-lb__x", lb).addEventListener("click", () => closeLB(S));
    $(".rvp-lb__nav--p", lb).addEventListener("click", () => lbGo(S, S.lbI - 1));
    $(".rvp-lb__nav--n", lb).addEventListener("click", () => lbGo(S, S.lbI + 1));
    $(".rvp-lb__thumbs", lb).addEventListener("click", (e) => { const b = e.target.closest("[data-k]"); if (b) lbGo(S, +b.dataset.k); });
    let r2 = 0;
    tr.addEventListener("scroll", () => { cancelAnimationFrame(r2); r2 = requestAnimationFrame(() => { const k = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); if (k !== S.lbI) { unzoom(S); S.lbI = k; lbMark(S, k); } }); }, { passive: true });

    /* Zoom: Tippen/Klicken schaltet, Bewegen führt den Ausschnitt mit */
    let down = null;
    const origin = (s, x, y) => {
      const img = $("img", s); const r = img.getBoundingClientRect();
      const ox = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
      const oy = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
      img.style.transformOrigin = `${ox}% ${oy}%`;
    };
    tr.addEventListener("pointerdown", (e) => { down = { x: e.clientX, y: e.clientY }; });
    tr.addEventListener("pointermove", (e) => { const s = e.target.closest(".rvp-lb__s.is-zoom"); if (s) origin(s, e.clientX, e.clientY); });
    tr.addEventListener("pointerup", (e) => {
      if (!down) return;
      const moved = Math.hypot(e.clientX - down.x, e.clientY - down.y);
      down = null;
      const s = e.target.closest(".rvp-lb__s");
      if (!s || (moved > 8 && !s.classList.contains("is-zoom"))) return;
      if (moved > 8) return;
      if (s.classList.contains("is-zoom")) { unzoom(S); return; }
      origin(s, e.clientX, e.clientY);
      s.classList.add("is-zoom");
      tr.classList.add("is-zoom");
    });
    tr.addEventListener("pointercancel", () => { down = null; });
  }
  function unzoom(S) {
    if (!S.lb) return;
    $$(".rvp-lb__s.is-zoom", S.lb).forEach((s) => s.classList.remove("is-zoom"));
    $(".rvp-lb__track", S.lb).classList.remove("is-zoom");
  }
  function lbMark(S, k) {
    const lb = S.lb, n = $$(".rvp-lb__s", lb).length;
    $("#rvp-lbn").textContent = `${String(k + 1).padStart(2, "0")} / ${String(n).padStart(2, "0")}`;
    $$(".rvp-lb__th", lb).forEach((b) => b.classList.toggle("is-on", +b.dataset.k === k));
    $(".rvp-lb__nav--p", lb).disabled = k <= 0;
    $(".rvp-lb__nav--n", lb).disabled = k >= n - 1;
  }
  function lbGo(S, k) {
    const lb = S.lb; if (!lb) return;
    const n = $$(".rvp-lb__s", lb).length;
    k = Math.max(0, Math.min(n - 1, k));
    unzoom(S);
    const tr = $(".rvp-lb__track", lb);
    tr.scrollTo({ left: k * tr.clientWidth, behavior: beh() });
    S.lbI = k; lbMark(S, k);
  }
  function closeLB(S) {
    const lb = S.lb; if (!lb) return;
    lb.classList.remove("is-on");
    document.body.classList.remove("rvp-lb-open");
    if (!document.querySelector(".rv-panel.is-on,.rv-search.is-on")) document.body.classList.remove("rv-lock");
    const t = S.lbTrigger;
    S.lb = null;
    setTimeout(() => lb.remove(), reduce() ? 0 : 480);
    if (t && document.body.contains(t)) t.focus({ preventScroll: true });
  }
})();
